import styled from 'styled-components'

export const Title = styled.h1`
  font-size: 1.5em;
  margin: 1em;
  /* text-align: center; */
  color: #2e2d2d;
`
